import { render, staticRenderFns } from "./QuickCommend.vue?vue&type=template&id=f24fe186&scoped=true"
import script from "./QuickCommend.vue?vue&type=script&lang=js"
export * from "./QuickCommend.vue?vue&type=script&lang=js"
import style0 from "./QuickCommend.vue?vue&type=style&index=0&id=f24fe186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24fe186",
  null
  
)

export default component.exports